import { useIsWaitingForPredictions } from "@rapid/hooks/useIsWaitingForPredictions";
import Button from "@components/Button";
import { twClassNames } from "@scripts/react/helpers/twClassNames";
import { useFlow } from "@rapid/contexts/FlowContext";

interface GeneratePredictionsBtnProps {
    disabled?: boolean;
    onClick: (e: React.MouseEvent) => void;
}

export const GeneratePredictionsBtn = ({
    disabled = false,
    onClick
}: GeneratePredictionsBtnProps) => {
    const { isExtractingWithAI } = useFlow();
    const { isWaiting: isWaitingForPredictions, loadingMessage } =
        useIsWaitingForPredictions(isExtractingWithAI);

    return (
        <Button
            type="tertiary"
            aria-label="Find Objects"
            title="Find Objects"
            onClick={onClick}
            disabled={disabled || isWaitingForPredictions}
            className="border-brand"
            loadingText={loadingMessage}
            loading={isWaitingForPredictions}
        >
            Find Objects
            <div className={twClassNames("hotkeysContainer", disabled && "opacity-50")}>
                <div className="hotkey brand">⏎</div>
            </div>
        </Button>
    );
};
